import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // Header
      'header.title': 'Géomaticien SIG • Cartographie Drone — Sénégal',
      'header.home': 'Accueil',
      'header.poles': 'Pôles',
      'header.partnerships': 'Partenariats',
      'header.about': 'À propos',
      'header.vision': 'Ma vision',
      'header.skills': 'Compétences',
      'header.services': 'Services',
      'header.values': 'Valeurs',
      'header.projects': 'Projets',
      'header.experience': 'Expérience',
      'header.education': 'Formation',
      'header.interests': 'Intérêts',
      'header.contact': 'Contact',

      // Hero section
      'hero.name': 'Cheikh Ngom',
      'hero.subtitle': "Géomatique, Connectique NFC-IoT & Fabrication additive",
      'hero.brandTagline': "Géomatique & génie civil, NFC-IoT, impression 3D, cartes NFC — structure multi-pôles basée au Sénégal",
      'hero.description': "Baobab Square est une structure sénégalaise (NINEA 013238888) basée à Mbour, qui réunit quatre pôles complémentaires : géomatique & génie civil, connectique NFC-IoT, impression 3D et cartes de visite connectées. Elle accompagne entreprises, collectivités et porteurs de projets, du relevé terrain jusqu'à la solution numérique déployée.",
      'hero.cta.contact': 'Me contacter',
      'hero.cta.quote': 'Demander un devis',
      'whatsapp.quoteMessage': 'Bonjour, je souhaite un devis pour un projet (SIG, cartographie/drone, ou développement web, mobile ou desktop).',
      'hero.cta.services': 'Découvrir nos pôles',
      'hero.cta.download': 'Télécharger mon CV (Standard)',
      'hero.cta.downloadCanada': '🇨🇦 CV Format Canadien',

      // Poles section
      'poles.title': "Nos pôles d'activité",
      'poles.intro': "Baobab Square réunit quatre domaines complémentaires.",
      'poles.geomatics.title': 'Géomatique & Génie Civil',
      'poles.geomatics.items': [
        'Cartographie professionnelle et relevés drone/photogrammétrie',
        'Plateformes WebGIS et applications mobiles géolocalisées',
        "Cadastre numérique et aménagement du territoire"
      ],
      'poles.nfciot.title': 'NFC-IoT — Meubles & portes connectées',
      'poles.nfciot.items': [
        'Mobilier et systèmes d\'accès connectés (ESP32)',
        'Architecture offline-first avec batterie de secours',
        "Pensé pour un réseau électrique/internet non garanti"
      ],
      'poles.print3d.title': 'Impression 3D',
      'poles.print3d.items': [
        'Prototypage, pièces de remplacement, objets personnalisés',
        "Production locale, sans délai d'import",
        'Devis selon pièce, matériau et délai'
      ],
      'poles.nfccards.title': 'Cartes de visite NFC',
      'poles.nfccards.items': [
        'Un contact au smartphone pour partager coordonnées ou portfolio',
        'Aucune application à installer',
        'Personnalisation logo/design possible'
      ],
      'poles.cta': 'Demander un devis',

      // Partnerships section
      'partnerships.title': 'Partenariats & collaborations',
      'partnerships.description': "Baobab Square est ouvert à des collaborations techniques, de co-développement ou de distribution avec des acteurs de la géomatique, de l'IoT et de la fabrication additive. Structure enregistrée au Sénégal (NINEA 013 238 888), travaillant en français et en anglais.",
      'partnerships.cta.whatsapp': 'Discuter sur WhatsApp',
      'partnerships.cta.onepager_fr': 'One-pager (FR)',
      'partnerships.cta.onepager_en': 'One-pager (EN)',
      'partnerships.cta.linkedin': 'LinkedIn',

      // Stats section
      'stats.poles': 'Pôles d\'activité',
      'stats.turnaround': 'Délai de devis gratuit',
      'stats.years': 'Ans d\'expérience terrain',
      'stats.languages': 'Langues de travail (FR/EN)',

      // About section
      'about.title': 'À propos',
      'about.intro': 'Je suis **Cheikh NGOM**, spécialiste en géomatique et développement d\'applications, passionné par l\'innovation numérique et l\'exploitation intelligente des données spatiales.',
      'about.description': 'Mon parcours en Licence 3 Géomatique & Développement d\'Applications (ISI Dakar, mention Bien — 13,64/20) m\'a permis d\'acquérir une expertise solide dans la manipulation des données géospatiales, la conception d\'outils informatiques adaptés et la réalisation de projets techniques et opérationnels en production réelle.',
      'about.pillars.title': 'Trois piliers essentiels',
      'about.pillars.items': [
        { title: 'La rigueur technique', description: 'approche méthodique et précise' },
        { title: 'La compréhension fine des besoins', description: 'écoute et adaptation aux spécificités' },
        { title: 'La recherche de solutions simples et efficaces', description: 'optimisation et performance' }
      ],
      'about.clients': 'J\'accorde une grande importance à la qualité des livrables, à la lisibilité des interfaces et à l\'optimisation des performances. J\'interviens auprès de particuliers, de startups, d\'entreprises, d\'institutions publiques et de projets académiques.',
      'about.email': 'Email :',
      'about.phone': 'Téléphone :',
      'about.birthdate': 'Date de naissance :',
      'about.location': 'Localisation :',
      'about.location_value': 'Mbour, km1 route de Joal, Thiès – Sénégal',
      'about.license': 'Permis de conduire B',
      'about.availability': 'Disponible pour se déplacer selon les besoins',
      'about.linkedin': 'LinkedIn :',
      'about.work_mode': 'Télétravail ou présentiel',

      // Vision section
      'vision.title': 'Ma vision',
      'vision.description': 'Je considère la géomatique comme un levier stratégique permettant de :',
      'vision.points': [
        'améliorer la gestion de l\'information',
        'optimiser la prise de décision',
        'digitaliser les processus',
        'moderniser les services',
        'et valoriser les données'
      ],

      // Skills section
      'skills.title': 'Compétences techniques et professionnelles',
      'skills.categories.gis.title': 'SIG & Analyse spatiale',
      'skills.categories.gis.items': [
        'QGIS, ArcGIS Pro (PyQGIS, scripts automatisation)',
        'Analyse thématique et spatiale avancée',
        'Création de cartes professionnelles',
        'Géocodage, géoréférencement, projections (EPSG:32628)',
        'PostGIS — calculs de surfaces, buffers, intersections',
        'GDAL, GeoPandas, Shapely, Fiona, pyproj',
        'KoboCollect, QField (collecte terrain)'
      ],
      'skills.categories.photogrammetry.title': 'Photogrammétrie & Drones',
      'skills.categories.photogrammetry.items': [
        'Traitement d\'images aériennes & drone',
        'Orthomosaïques haute résolution',
        'Création de MNT et DSM',
        'Intégration WebGIS des orthophotos',
        'Correction, nettoyage et optimisation'
      ],
      'skills.categories.web.title': 'Développement web',
      'skills.categories.web.items': [
        'HTML, CSS, JavaScript, TypeScript',
        'Python : Django REST Framework, FastAPI',
        'PHP : Laravel 11/12',
        'React 19, Vite, TailwindCSS, Material-UI',
        'Node.js, Express.js',
        'Leaflet, MapLibre GL, Mapbox, Deck.gl',
        'Développement full-stack & Intégration API REST'
      ],
      'skills.categories.mobile.title': 'Développement mobile & desktop',
      'skills.categories.mobile.items': [
        'Flutter (Android + iOS) — apps cartographiques',
        'React Native / Expo',
        'Python PySide6 (applications desktop cadastrales)',
        'PyInstaller — packaging EXE standalone'
      ],
      'skills.categories.databases.title': 'Bases de données',
      'skills.categories.databases.items': [
        'PostgreSQL / PostGIS — données spatiales',
        'MySQL, SQLite',
        'Conception de schémas et optimisation des requêtes',
        'Formats SIG : SHP, GeoPackage, GeoJSON, DXF, KML'
      ],
      'skills.categories.design.title': 'Conception & Architecture',
      'skills.categories.design.items': [
        'Analyse des besoins et études fonctionnelles',
        'UML, modélisation orientée objet',
        'Architecture applicative (MVC, REST, microservices)'
      ],
      'skills.categories.systems.title': 'Cloud, Déploiement & Sécurité',
      'skills.categories.systems.items': [
        'Linux, Windows | Git / GitHub',
        'AWS (EC2, RDS, S3, Lambda/SES)',
        'Firebase Hosting, Vercel',
        'Nginx + Gunicorn + systemd (Linux prod)',
        'OWASP Top 10, JWT, HSTS, Rate Limiting, CORS',
        'PyInstaller (packaging EXE desktop)'
      ],

      // Experience section
      'experience.title': 'Expérience Professionnelle',
      'experience.items': [
        {
          title: 'GEOXPRT AFRIQUE – Développeur géospatial & Applications',
          subtitle: 'Contrat (sept. 2025 – présent)',
          description: "Développement de plateformes SIG et d'applications web, mobile et desktop pour le secteur cadastral. Architecture Django DRF / React 19 / Flutter / PostgreSQL PostGIS.",
          tasks: [
            'Plateformes WebGIS pour la gestion parcellaire et cadastrale, avec sécurité applicative (OWASP)',
            'Applications mobiles de terrain avec cartographie embarquée et géolocalisation',
            'Applications desktop pour la génération de documents cadastraux officiels',
            'Portails web multilingues avec services cloud (AWS, déploiement automatisé)'
          ]
        },
        {
          title: 'GETRAB CONS – Stagiaire développeur SIG',
          subtitle: 'Stage (2024)',
          description: 'Stage en développement d\'applications géospatiales et géoportail web.',
          tasks: [
            'Développement d\'une application de gestion parcellaire',
            'Création d\'un géoportail web interactif',
            'Collecte terrain (KoboCollect, QField) + analyse spatiale (QGIS, PostGIS)',
            'Rédaction de rapports techniques SIG'
          ]
        }
      ],

      // Projects section
      'projects.title': 'Projets et Réalisations',
      'projects.intro': 'Découvrez mes réalisations professionnelles chez GEOXPRT AFRIQUE, alliant expertise technique en géomatique et développement full-stack moderne.',
      'projects.visit': 'Voir le projet',
      'projects.access_notice': 'Accès sur demande : pour préserver les données clients, merci de me solliciter avant de visiter les applications. Je vous fournirai les identifiants ou liens sécurisés nécessaires.',
      'projects.autoplan': {
        cta: 'Demander une démo',
        description: 'Application desktop PySide6 pour générer des extraits de plan cadastraux conformes à partir de DXF, CSV ou saisies manuelles, avec cartographie Leaflet embarquée et pipeline PDF automatisé.',
        features: [
          'Import DXF, CSV et saisie manuelle des bornes avec numérotation intelligente',
          'Double visualisation : vue technique 2D + carte satellite Leaflet via QWebEngineView',
          'Calculs géométriques précis (superficie, périmètre, fermeture, conversions UTM 28N ↔ WGS84)',
          'Génération PDF ReportLab avec plan de situation, tableau des coordonnées et mentions légales',
          'Système de crédits sécurisé (1 borne = 1 crédit) avec historique chiffré et alertes de solde',
          'Packaging PyInstaller pour livrer un EXE autonome prêt pour les agents cadastraux'
        ]
      },

      // Education section
      'education.title': 'Formation',
      'education.licence3.title': 'Licence 3 en Géomatique et Développement d\'Applications',
      'education.licence3.institution': 'Institut Supérieur d\'Informatique (ISI Dakar)',
      'education.licence3.period': '2022 – 2025',
      'education.licence3.description': 'Mention Bien — Moyenne : 13,64/20. Cours : télédétection, développement web, bases de données, modélisation spatiale, scripting Python/Bash, réseaux, SIG avancé.',
      'education.thesis.title': 'Mémoire de Licence – 2025 (soutenu)',
      'education.thesis.institution': 'Institut Supérieur d\'Informatique',
      'education.thesis.period': '2024 – 2025',
      'education.thesis.description': 'Apport de la géomatique à la gestion des terrains synthétiques – Cas du département de Dakar.',
      'education.thesis.points': [
        'Recensement de 12 terrains synthétiques, collecte et structuration des données spatiales',
        'Développement d\'une plateforme géomatique de gestion et de réservation : carte interactive, back-office, système de réservation',
        'Chaîne de traitement : Leaflet, React, PostGIS, Laravel, PostgreSQL, Vercel',
        'Application toujours en cours d\'industrialisation pour déploiement terrain'
      ],
      'education.bac.title': 'Baccalauréat Littéraire L2',
      'education.bac.institution': 'Sénégal',
      'education.bac.period': '2020',
      'education.bac.description': 'Formation en sciences humaines',

      // Certifications
      'certifications.title': 'Certifications & Cours suivis',
      'certifications.ucdavis_vector': 'Geospatial Foundations & Vector Analysis — University of California, Davis (Coursera, 9 août 2026) — note : 98,75 %',
      'certifications.ucdavis_arcgis': 'Geospatial Analysis with ArcGIS — University of California, Davis (Coursera, 5 août 2026) — note : 94,09 %',
      'certifications.aws': 'AWS Cloud Practitioner Essentials — Amazon Web Services (Coursera, 3 août 2026) — note : 97,90 %',
      'certifications.iot': 'Introduction to the Internet of Things and Embedded Systems — University of California, Irvine (Coursera, juillet 2026)',
      'certifications.verify': '(vérifier)',
      'certifications.web': 'Cours en développement web fullstack (React, Laravel, Django, API REST)',
      'certifications.agisoft': 'Initiation à Agisoft Metashape pour modélisation 3D et orthomosaïques',
      'certifications.arcgis': 'Certification en cours de préparation : ArcGIS Pro Associate 2025 (Esri)',
      'certifications.digital': 'Formation continue prévue : Digital Earth Africa (automatisation SIG)',

      // Additional skills
      'additional.title': 'Atouts supplémentaires',
      'additional.teamwork': 'Travail en équipe et sens de l\'initiative',
      'additional.adaptability': 'Adaptabilité rapide à de nouveaux outils et technologies',
      'additional.international': 'Disponible pour missions à l\'international',
      'additional.passion': 'Forte passion pour la cartographie, l\'environnement, la géomatique et l\'innovation digitale',

      // Services section
      'services.title': 'Services',
      'services.intro': 'Des solutions sur-mesure en SIG, cartographie drone et développement web, mobile & desktop (Django, React, Flutter, PostGIS) pour entreprises, collectivités et particuliers au Sénégal.',
      'services.cta': 'Demander un devis gratuit',
      'services.web.title': 'Développement Web, Mobile & Desktop',
      'services.web.items': [
        'Plateformes WebGIS (Leaflet, MapLibre GL, Mapbox)',
        'Applications web full-stack (Django, React, Laravel)',
        'Applications mobiles Flutter avec géolocalisation (Android + iOS)',
        'Applications desktop Python (PySide6) packagées en EXE autonome (PyInstaller)',
        'Applications métiers pour le secteur cadastral (génération de plans, gestion parcellaire)',
        'Déploiement AWS / Firebase / Vercel',
        'APIs REST sécurisées et documentées'
      ],
      'services.gis.title': 'SIG & Cartographie',
      'services.gis.items': [
        'Conception de cartes thématiques de haute qualité',
        'Création de bases de données spatiales (PostGIS)',
        'Analyses spatiales avancées (QGIS, ArcGIS Pro, PyQGIS)',
        'Géoréférencement, projections et préparation technique',
        'Intégration de données SIG dans des plateformes web'
      ],
      'services.photogrammetry.title': 'Photogrammétrie',
      'services.photogrammetry.items': [
        'Traitement d\'images aériennes et drone',
        'Orthomosaïques professionnelles',
        'MNT/DSM',
        'Correction, colorimétrie, optimisation',
        'Intégration dans des systèmes SIG ou WebGIS'
      ],
      'services.consulting.title': 'Analyse & Conseil',
      'services.consulting.items': [
        'Étude des besoins et propositions techniques',
        'Documentation et formation',
        'Accompagnement dans la transformation digitale',
        'Audit sécurité applicative (OWASP)',
        'Mise en place de solutions géospatiales complètes'
      ],

      // Values section
      'values.title': 'Valeurs & Engagements',
      'values.items': [
        { title: 'Qualité',        description: 'chaque livrable est vérifié, testé et documenté' },
        { title: 'Fiabilité',      description: 'respect des délais, engagements clairs' },
        { title: 'Compréhension',  description: 'adaptation aux besoins spécifiques' },
        { title: 'Innovation',     description: 'utilisation de technologies modernes' },
        { title: 'Transparence',   description: 'communication continue avec les clients' }
      ],

      // Interests section
      'interests.title': 'Centres d\'Intérêt et Langues',
      'interests.interests': 'Centres d\'Intérêt',
      'interests.interests.description': 'Mes centres d\'intérêt incluent la programmation, les technologies émergentes, le design créatif, le football et les divertissements.',
      'interests.languages': 'Langues',
      'interests.french': 'Français : Langue maternelle',
      'interests.english': 'Anglais : Intermédiaire (lecture technique, documentation, rédaction)',
      'interests.wolof': 'Wolof : Courant',

      // Contact section
      'contact.title': 'Contact',
      'contact.info': 'Informations de Contact',
      'contact.social': 'Réseaux Sociaux',
      'contact.availability': 'Disponibilité :',
      'contact.availability.value': 'Présentiel & Télétravail',
      'contact.downloads': 'Documents à télécharger',
      'contact.downloads.card': 'Carte de visite (PDF)',
      'contact.downloads.flyer': 'Plaquette de services (PDF)',

      // Languages
      'language.fr': 'Français',
      'language.en': 'English'
    }
  },
  en: {
    translation: {
      // Header
      'header.title': 'GIS & Drone Mapping Specialist — Senegal',
      'header.home': 'Home',
      'header.poles': 'Areas',
      'header.partnerships': 'Partnerships',
      'header.about': 'About',
      'header.vision': 'My Vision',
      'header.skills': 'Skills',
      'header.services': 'Services',
      'header.values': 'Values',
      'header.projects': 'Projects',
      'header.experience': 'Experience',
      'header.education': 'Education',
      'header.interests': 'Interests',
      'header.contact': 'Contact',

      // Hero section
      'hero.name': 'Cheikh Ngom',
      'hero.subtitle': 'Geomatics, NFC-IoT Connected Hardware & Additive Manufacturing',
      'hero.brandTagline': "Geomatics & civil engineering, NFC-IoT, 3D printing, NFC cards — a multi-area venture based in Senegal",
      'hero.description': "Baobab Square is a Senegal-registered company (NINEA 013238888) based in Mbour, bringing together four complementary areas: geomatics & civil engineering, NFC-IoT connected hardware, 3D printing and connected business cards. It supports businesses, local authorities and project owners from field survey through to deployed digital solutions.",
      'hero.cta.contact': 'Contact me',
      'hero.cta.quote': 'Request a quote',
      'whatsapp.quoteMessage': 'Hello, I would like a quote for a project (GIS, mapping/drone, or web, mobile or desktop development).',
      'hero.cta.services': 'Discover our areas',
      'hero.cta.download': 'Download my résumé (Standard)',
      'hero.cta.downloadCanada': '🇨🇦 Canadian Format CV',

      // Poles section
      'poles.title': 'Our Areas of Activity',
      'poles.intro': 'Baobab Square brings together four complementary areas.',
      'poles.geomatics.title': 'Geomatics & Civil Engineering',
      'poles.geomatics.items': [
        'Professional mapping and drone/photogrammetry surveys',
        'WebGIS platforms and geolocated mobile applications',
        'Digital cadastre and land administration'
      ],
      'poles.nfciot.title': 'Connected Furniture & Smart Access (NFC-IoT)',
      'poles.nfciot.items': [
        'ESP32-based smart furniture and access systems',
        'Offline-first architecture with battery backup',
        "Designed for regions where power/network isn't always reliable"
      ],
      'poles.print3d.title': '3D Printing',
      'poles.print3d.items': [
        'Prototyping, replacement parts, custom objects',
        'Produced locally, no import delays',
        'Quote based on part, material and turnaround'
      ],
      'poles.nfccards.title': 'NFC Business Cards',
      'poles.nfccards.items': [
        'Tap-to-share contacts and portfolio, no app required',
        'Custom branding available',
        'Pricing on request'
      ],
      'poles.cta': 'Request a quote',

      // Partnerships section
      'partnerships.title': 'Partnerships & Collaborations',
      'partnerships.description': "Baobab Square is open to technical, co-development or distribution partnerships with organisations in geomatics, IoT and additive manufacturing. Registered business in Senegal (NINEA 013 238 888), working in French and English.",
      'partnerships.cta.whatsapp': 'Chat on WhatsApp',
      'partnerships.cta.onepager_fr': 'One-pager (FR)',
      'partnerships.cta.onepager_en': 'One-pager (EN)',
      'partnerships.cta.linkedin': 'LinkedIn',

      // Stats section
      'stats.poles': 'Areas of activity',
      'stats.turnaround': 'Free quote turnaround',
      'stats.years': 'Years of field experience',
      'stats.languages': 'Working languages (FR/EN)',

      // About section
      'about.title': 'About',
      'about.intro': 'I am **Cheikh NGOM**, a specialist in geomatics and application development, passionate about digital innovation and intelligent exploitation of spatial data.',
      'about.description': 'My Bachelor\'s degree in Geomatics & Application Development (ISI Dakar, Distinction — 13.64/20) gave me solid expertise in geospatial data handling, design of purpose-built IT tools and delivery of technical projects running in real production.',
      'about.pillars.title': 'Three essential pillars',
      'about.pillars.items': [
        { title: 'Technical rigor', description: 'methodical and precise approach' },
        { title: 'Fine understanding of needs', description: 'listening and adaptation to specificities' },
        { title: 'Search for simple and effective solutions', description: 'optimization and performance' }
      ],
      'about.clients': 'I place great importance on the quality of deliverables, interface readability and performance optimization. I work with individuals, startups, companies, public institutions and academic projects.',
      'about.email': 'Email:',
      'about.phone': 'Phone:',
      'about.birthdate': 'Date of birth:',
      'about.location': 'Location:',
      'about.location_value': 'Mbour, km 1 route de Joal, Thiès – Senegal',
      'about.license': 'Driver\'s License B',
      'about.availability': 'Available to travel as needed',
      'about.linkedin': 'LinkedIn:',
      'about.work_mode': 'Remote work or on-site',

      // Vision section
      'vision.title': 'My Vision',
      'vision.description': 'I consider geomatics as a strategic lever to:',
      'vision.points': [
        'improve information management',
        'optimize decision-making',
        'digitize processes',
        'modernize services',
        'and enhance data value'
      ],

      // Skills section
      'skills.title': 'Technical and Professional Skills',
      'skills.categories.gis.title': 'GIS & Spatial Analysis',
      'skills.categories.gis.items': [
        'QGIS, ArcGIS Pro (PyQGIS, automation scripts)',
        'Thematic and advanced spatial analysis',
        'Professional map creation',
        'Geocoding, georeferencing, projections (EPSG:32628)',
        'PostGIS — surfaces, buffers, intersections',
        'GDAL, GeoPandas, Shapely, Fiona, pyproj',
        'KoboCollect, QField (field data collection)'
      ],
      'skills.categories.photogrammetry.title': 'Photogrammetry & Drone Data',
      'skills.categories.photogrammetry.items': [
        'Aerial & drone image processing',
        'High resolution orthomosaics',
        'DTM and DSM creation',
        'WebGIS integration of orthophotos',
        'Correction, cleaning and optimization'
      ],
      'skills.categories.web.title': 'Web Development',
      'skills.categories.web.items': [
        'HTML, CSS, JavaScript, TypeScript',
        'Python: Django REST Framework, FastAPI',
        'PHP: Laravel 11/12',
        'React 19, Vite, TailwindCSS, Material-UI',
        'Node.js, Express.js',
        'Leaflet, MapLibre GL, Mapbox, Deck.gl',
        'Full-stack development & REST API integration'
      ],
      'skills.categories.mobile.title': 'Mobile & Desktop Development',
      'skills.categories.mobile.items': [
        'Flutter (Android + iOS) — mapping apps',
        'React Native / Expo',
        'Python PySide6 (cadastral desktop apps)',
        'PyInstaller — standalone EXE packaging'
      ],
      'skills.categories.databases.title': 'Databases',
      'skills.categories.databases.items': [
        'PostgreSQL / PostGIS — spatial data',
        'MySQL, SQLite',
        'Schema design and query optimization',
        'GIS formats: SHP, GeoPackage, GeoJSON, DXF, KML'
      ],
      'skills.categories.design.title': 'Design & Architecture',
      'skills.categories.design.items': [
        'Requirements analysis and functional studies',
        'UML, object-oriented modeling',
        'Application architecture (MVC, REST, microservices)'
      ],
      'skills.categories.systems.title': 'Cloud, Deployment & Security',
      'skills.categories.systems.items': [
        'Linux, Windows | Git / GitHub',
        'AWS (EC2, RDS, S3, Lambda/SES)',
        'Firebase Hosting, Vercel',
        'Nginx + Gunicorn + systemd (Linux prod)',
        'OWASP Top 10, JWT, HSTS, Rate Limiting, CORS',
        'PyInstaller (desktop EXE packaging)'
      ],

      // Experience section
      'experience.title': 'Professional Experience',
      'experience.items': [
        {
          title: 'GEOXPRT AFRIQUE – Geospatial & Application Developer',
          subtitle: 'Employment (Sept. 2025 – present)',
          description: 'Development of GIS platforms and web, mobile and desktop applications for the cadastral sector. Architecture: Django DRF / React 19 / Flutter / PostgreSQL PostGIS.',
          tasks: [
            'WebGIS platforms for parcel and cadastral management, with application security (OWASP)',
            'Field mobile applications with embedded mapping and geolocation',
            'Desktop applications for generating official cadastral documents',
            'Multilingual web portals with cloud services (AWS, automated deployment)'
          ]
        },
        {
          title: 'GETRAB CONS – GIS Developer Intern',
          subtitle: 'Internship (2024)',
          description: 'Internship in geospatial application development and web geoportal.',
          tasks: [
            'Development of a parcel management application',
            'Creation of an interactive web geoportal',
            'Field data collection (KoboCollect, QField) + spatial analysis (QGIS, PostGIS)',
            'Technical GIS report writing'
          ]
        }
      ],

      // Projects section
      'projects.title': 'Projects & Achievements',
      'projects.intro': 'Discover my professional achievements at GEOXPRT AFRIQUE, combining geomatics expertise and modern full-stack development.',
      'projects.visit': 'View project',
      'projects.access_notice': 'Access on request: to protect client data, please contact me before accessing the applications. I will provide the appropriate credentials or secure links.',
      'projects.autoplan': {
        cta: 'Request a demo',
        description: 'PySide6 desktop application generating official cadastral plan extracts from DXF, CSV or manual inputs, with embedded Leaflet mapping and an automated PDF production pipeline.',
        features: [
          'DXF, CSV and manual point imports with smart vertex numbering',
          'Dual visualization: technical 2D canvas + Leaflet satellite map via QWebEngineView',
          'Accurate geometry processing (area, perimeter, polygon closure, UTM 28N ↔ WGS84 conversions)',
          'ReportLab PDF generation with situational map, coordinate table and legal notices',
          'Secure credit system (1 vertex = 1 credit) with encrypted history and balance alerts',
          'PyInstaller packaging delivering a standalone EXE for cadastral officers'
        ]
      },

      // Education section
      'education.title': 'Education',
      'education.licence3.title': 'Bachelor\'s in Geomatics and Application Development',
      'education.licence3.institution': 'Institut Supérieur d\'Informatique (ISI Dakar)',
      'education.licence3.period': '2022 – 2025',
      'education.licence3.description': 'Distinction — GPA: 13.64/20. Courses: remote sensing, web development, databases, spatial modeling, Python/Bash scripting, networking, advanced GIS.',
      'education.thesis.title': 'Bachelor\'s thesis – 2025 (defended)',
      'education.thesis.institution': 'Institut Supérieur d\'Informatique',
      'education.thesis.period': '2024 – 2025',
      'education.thesis.description': 'Contribution of geomatics to synthetic field management – Dakar department case study.',
      'education.thesis.points': [
        'Surveyed 12 synthetic fields, collected and structured spatial datasets',
        'Built a geomatics management & booking platform: interactive map, back-office, reservation workflow',
        'Technical stack: Leaflet, React, PostGIS, Laravel, PostgreSQL, Vercel',
        'Application remains under active development for production rollout'
      ],
      'education.bac.title': 'Literary Baccalaureate L2',
      'education.bac.institution': 'Senegal',
      'education.bac.period': '2020',
      'education.bac.description': 'Human sciences training',

      // Certifications
      'certifications.title': 'Certifications & Courses',
      'certifications.ucdavis_vector': 'Geospatial Foundations & Vector Analysis — University of California, Davis (Coursera, August 9, 2026) — score: 98.75%',
      'certifications.ucdavis_arcgis': 'Geospatial Analysis with ArcGIS — University of California, Davis (Coursera, August 5, 2026) — score: 94.09%',
      'certifications.aws': 'AWS Cloud Practitioner Essentials — Amazon Web Services (Coursera, August 3, 2026) — score: 97.90%',
      'certifications.iot': 'Introduction to the Internet of Things and Embedded Systems — University of California, Irvine (Coursera, July 2026)',
      'certifications.verify': '(verify)',
      'certifications.web': 'Fullstack web development course (React, Laravel, Django, REST API)',
      'certifications.agisoft': 'Introduction to Agisoft Metashape for 3D modeling and orthomosaics',
      'certifications.arcgis': 'Certification in progress: ArcGIS Pro Associate 2025 (Esri)',
      'certifications.digital': 'Planned continuing education: Digital Earth Africa (GIS automation)',

      // Additional skills
      'additional.title': 'Additional assets',
      'additional.teamwork': 'Teamwork and initiative',
      'additional.adaptability': 'Rapid adaptability to new tools and technologies',
      'additional.international': 'Available for international missions',
      'additional.passion': 'Strong passion for cartography, environment, geomatics and digital innovation',

      // Services section
      'services.title': 'Services',
      'services.intro': 'Tailored solutions in GIS, drone mapping and web, mobile & desktop development (Django, React, Flutter, PostGIS) for businesses, local authorities and individuals in Senegal.',
      'services.cta': 'Request a free quote',
      'services.web.title': 'Web, Mobile & Desktop Development',
      'services.web.items': [
        'WebGIS platforms (Leaflet, MapLibre GL, Mapbox)',
        'Full-stack web apps (Django, React, Laravel)',
        'Flutter mobile apps with geolocation (Android + iOS)',
        'Python desktop apps (PySide6) packaged as standalone EXE (PyInstaller)',
        'Business applications for the cadastral sector (plan generation, parcel management)',
        'AWS / Firebase / Vercel deployment',
        'Secure and documented REST APIs'
      ],
      'services.gis.title': 'GIS & Cartography',
      'services.gis.items': [
        'High-quality thematic map design',
        'Spatial database creation (PostGIS)',
        'Advanced spatial analysis (QGIS, ArcGIS Pro, PyQGIS)',
        'Georeferencing, projections and technical preparation',
        'GIS data integration into web platforms'
      ],
      'services.photogrammetry.title': 'Photogrammetry',
      'services.photogrammetry.items': [
        'Aerial and drone image processing',
        'Professional orthomosaics',
        'DTM/DSM',
        'Correction, colorimetry, optimization',
        'Integration into GIS or WebGIS systems'
      ],
      'services.consulting.title': 'Analysis & Consulting',
      'services.consulting.items': [
        'Needs study and technical proposals',
        'Documentation and training',
        'Digital transformation support',
        'Application security audit (OWASP)',
        'Complete geospatial solution deployment'
      ],

      // Values section
      'values.title': 'Values & Commitments',
      'values.items': [
        { title: 'Quality',       description: 'each deliverable is checked, tested and documented' },
        { title: 'Reliability',   description: 'respect for deadlines, clear commitments' },
        { title: 'Understanding', description: 'adaptation to specific needs' },
        { title: 'Innovation',    description: 'use of modern technologies' },
        { title: 'Transparency',  description: 'continuous communication with clients' }
      ],

      // Interests section
      'interests.title': 'Interests and Languages',
      'interests.interests': 'Interests',
      'interests.interests.description': 'My interests include programming, emerging technologies, creative design, football and entertainment.',
      'interests.languages': 'Languages',
      'interests.french': 'French: Native language',
      'interests.english': 'English: Intermediate (technical reading, documentation, writing)',
      'interests.wolof': 'Wolof: Fluent',

      // Contact section
      'contact.title': 'Contact',
      'contact.info': 'Contact Information',
      'contact.social': 'Social Networks',
      'contact.availability': 'Availability:',
      'contact.availability.value': 'On-site & Remote work',

      // Languages
      'language.fr': 'Français',
      'language.en': 'English'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: { escapeValue: false },
  });

export default i18n;
